import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { BarChart3 } from 'lucide-react';

const ratingClass = (rating) => {
  if (rating?.includes('Buy')) return 'bg-green-600';
  if (rating?.includes('Sell')) return 'bg-red-600';
  return 'bg-yellow-500';
};

const ConsensusCard = ({ analystData }) => (
  <Card className="hover:shadow-lg transition-shadow" data-testid="research-consensus-card">
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-lg">
        <BarChart3 className="text-purple-600" size={20} />
        Analyst Consensus
      </CardTitle>
    </CardHeader>
    <CardContent>
      {analystData ? (
        <div className="space-y-3">
          <div className="text-center mb-4">
            <Badge className={`text-lg px-4 py-2 ${ratingClass(analystData.rating)} text-white`}>
              {analystData.rating || 'Hold'}
            </Badge>
            {analystData.ratingScore && (
              <p className="text-xs text-gray-500 mt-1">Score: {analystData.ratingScore}/5</p>
            )}
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Target Price</span>
            <span className="font-medium">${analystData.targetPrice?.toFixed(2) || 'N/A'}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Upside</span>
            <span className={`font-medium ${analystData.upside >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              {analystData.upside?.toFixed(1) || '0'}%
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Total Analysts</span>
            <span className="font-medium">{analystData.consensus?.total || 'N/A'}</span>
          </div>
          <div className="text-xs text-gray-400 mt-2">
            Sources: {analystData.dataSources?.join(', ') || 'Yahoo Finance'}
          </div>
        </div>
      ) : (
        <p className="text-gray-500 text-sm">Search for a stock to see analyst data</p>
      )}
    </CardContent>
  </Card>
);

export default ConsensusCard;
